/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./DonorEmailVerified.css";
import { simpleFetch } from "../../restWrapper";
import PropTypes from "prop-types";
//import Promise from 'bluebird';

class DonorEmailVerified extends Component {
  constructor() {
    super();
    this.state = {
      fetching: true,
      isDonor: true,
      isOrg: false,
    };
    this.btnClick = this.btnClick.bind(this);
  }

  componentDidMount() {
    const path = this.props.location.pathname;
    const token = path.split("/DonorEmailVerified/")[1];
    // No token means we arrived from the VerifyCode flow — the email was
    // already verified via code, so just show the success UI.
    if (!token) {
      this.setState({ fetching: false });
      return;
    }
    this.handleToken(token);
  }

  handleToken(token) {
    /*
    Promise.all([
      this.handleUserToken(token, 'donors'),
      this.handleUserToken(token, 'organizations')
    ]).then((res) => {
      this.setState({
        fetching:false
      });
      if(res[0] === true){
        this.setState({
          isDonor: true
        });
      }else if(res[1] === true){
        this.setState({
          isOrg: true
        });
      }else {
        this.fail();
      }
    });
    */
    this.handleUserToken(token, "donors");
  }

  handleUserToken(token, userType) {
    const url = "/" + userType + "/register/" + token;
    simpleFetch(url, "GET").then((res) => {
      this.setState({
        fetching: false,
      });
      if (res.status !== 204) this.fail();
      return true;
    });
  }

  fail() {
    this.props.history.push({ pathname: "/ErrorPrompt" });
  }

  btnClick() {
    if (this.state.isOrg) this.props.history.push({ pathname: "/OrgLogin" });
  }

  render() {
    if (this.state.fetching) {
      return <this.props.RenderFullPageLoading />;
    }
    const languageObj = this.props.languageObj;
    return (
      <div className="DonorEmailVerified-view">
        <div className="DonorEmailVerified-prompt">
          <div className="DonorEmailVerified-loginContainer">
            <div className="DonorEmailVerified-mailVerifyIcn"></div>
            <div className="DonorEmailVerified-heading">
              {languageObj.text1}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
DonorEmailVerified.propTypes = {
  languageObj: PropTypes.object,
};

export default DonorEmailVerified;
